import styled from 'styled-components';
import { Message } from '@lux/message';

export const StyledBanner = styled(Message)`
    position: relative;
    z-index: -1;
`;
